import { Component, ElementRef, HostListener, OnInit, Renderer2 } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { MiscService } from 'app/shared/misc.service';
import { getUserPermissions, getUserRoleName } from 'app/shared/permissions/permission.service';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { filter, finalize } from 'rxjs/operators';

@Component({
  selector: 'app-seminav',
  templateUrl: './seminav.component.html',
  styleUrls: ['./seminav.component.scss']
})
export class SeminavComponent implements OnInit {
  title: string = '';
  description: string = '';
  breadcrumb: any[] = [];
  action: any = null;
  backButton: any = null;
  merchant: any;
  disbursementRole: string = '';
  tooltipElement: HTMLElement | null = null;
  showTooltip = false;
  loading = false;
  constructor(
    private route: ActivatedRoute,
    private toastr: ToastrService,
    private router: Router,
    public miscService: MiscService,
  ) {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.title = this.route.snapshot.firstChild?.firstChild?.data?.title;
      this.description = this.route.snapshot.firstChild?.firstChild?.data?.desc;
      this.breadcrumb = this.route.snapshot.firstChild?.firstChild?.data?.breadcrumb;

      // Traverse route tree for action and backButton
      this.action = this.getActionFromRoute(this.route.snapshot);
      this.backButton = this.getBackButtonFromRoute(this.route.snapshot);
    });

  }

  getActionFromRoute(route: any): any {
    // Traverse the route tree to find action data
    let currentRoute = route;
    while (currentRoute) {
      if (currentRoute.data?.action) {
        const requiredPerm = currentRoute.data?.disbursementPermission;
        if (requiredPerm && !this.hasDisbursementPermission(requiredPerm)) {
          return null;
        }
        return currentRoute.data.action;
      }
      // Check children
      if (currentRoute.firstChild) {
        currentRoute = currentRoute.firstChild;
      } else if (currentRoute.children && currentRoute.children.length > 0) {
        currentRoute = currentRoute.children[0];
      } else {
        break;
      }
    }
    return null;
  }

  hasDisbursementPermission(permission: string): boolean {
    const userPermissions = getUserPermissions();
    if (!userPermissions) return true; // merchant has full access
    for (const permObj of userPermissions) {
      if (permObj.hasOwnProperty('Disbursement')) {
        return permObj['Disbursement'][permission] === 1;
      }
    }
    return false;
  }

  getBackButtonFromRoute(route: any): any {
    // Traverse the route tree to find backButton data
    let currentRoute = route;
    while (currentRoute) {
      if (currentRoute.data?.backButton) {
        return currentRoute.data.backButton;
      }
      // Check children
      if (currentRoute.firstChild) {
        currentRoute = currentRoute.firstChild;
      } else if (currentRoute.children && currentRoute.children.length > 0) {
        currentRoute = currentRoute.children[0];
      } else {
        break;
      }
    }
    return null;
  }

  ngOnInit() {
    this.miscService.userSubject.subscribe(res => {
      if (res) {
        this.merchant = res;
      } else {
        this.merchant = this.miscService.getMerchantDetails();
      }
    });
    // Badge shows the assigned role name from the JWT (e.g. "All Permissions").
    this.disbursementRole = getUserRoleName();
  }

  handleActionClick(): void {
    if (this.action && this.action.route) {
      this.router.navigate([this.action.route]);
    }
  }

  handleBackClick(): void {
    if (this.backButton && this.backButton.route) {
      let route = this.backButton.route;

      // Replace dynamic route parameters (e.g., :customerId) with actual values from current route
      const routeParams = this.route.snapshot.firstChild?.firstChild?.params || {};
      Object.keys(routeParams).forEach(param => {
        route = route.replace(`:${param}`, routeParams[param]);
      });

      this.router.navigate([route]);
    }
  }

}
